import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ConstantesTabla from "../../utils/ConstantesTabla";
import Button from "../../components/atoms/buttons/Button";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import "./anexoI2.scss";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import { eliminarCentros, getCentrosSeleccionados, reodenarCentros } from "../../components/services/ConcursosService";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";

const CentrosOrdenPreferencia = () => {
  const [loading, setLoading] = useState(false);
  const [centrosSeleccionados, setCentrosSeleccionados] = useState();
  const [listaCentroBorrar, setListaCentroBorrar] = useState([]);
  const [nuevoOrdenCentrosSeleccionados, setNuevoOrdenCentrosSeleccionados] = useState([]);
  const [bloquearReordeno, setBloquearReordeno] = useState(false);
  const navigate = useNavigate();
  const [show, setShow] = useState({
    mensaje: false,
  });

  const params = useParams();
  // 

  const handleListaPuestoBorrar = (isChecked, puesto) => {
    if (isChecked) {
      // Agregar idPuesto al array si el checkbox está seleccionado
      setListaCentroBorrar((prevLista) => [...prevLista, puesto]);
    } else {
      // Eliminar idPuesto del array si el checkbox no está seleccionado
      setListaCentroBorrar((prevLista) => prevLista?.filter((item) => item !== puesto));
    }
  }

  

  let timer = null;
  const columnas = [
    {
      name: "Nuevo Orden",
      selector: (row, rowIndex) => {
        return (<>
          <div className="ordenAct row">
            <div className="col-6">
              <input type="number" name="" id="nuevoOrden" min={1} className="form-control"
                placeholder={rowIndex + 1}
                onChange={(event) => {
                  const orden = event.target.value;
                  if (orden !== "") {
                    clearTimeout(timer); // Reset the timer
                    timer = setTimeout(() => {
                      const newOrden = { xeocencon: row.xeocencon, orden: parseInt(orden) };
                      const index = nuevoOrdenCentrosSeleccionados.findIndex((o) => o.xeocencon === newOrden.xeocencon);
                      if (index !== -1) {
                        
                        // Actualizamos el objeto existente en el array si el orden es diferente
                        if (nuevoOrdenCentrosSeleccionados[index].orden !== newOrden.orden) {
                          
                          nuevoOrdenCentrosSeleccionados[index].orden = newOrden.orden;
                        }
                      }
                      if (nuevoOrdenCentrosSeleccionados.find((o) => o.orden === newOrden.orden && o.xeocencon !== newOrden.xeocencon)) {
                        alert(`Error: El orden ${newOrden.orden} ya existe en la lista`);
                        setBloquearReordeno(true);
                      } else {
                        setBloquearReordeno(false);
                      }
                    }, 500); // Wait 500ms before executing the code
                  }
                  
                }} />
            </div>
          </div>
        </>)
      },

      grow: 2,
      wrap: true,
    },
    {
      name: "Descripción del centro (Código)",
      selector: (row) => (<>
        <div className="descCentro">
          <div>{row.centro} ({row.codcentro})</div>
          <div>{row.localizacion}</div>
        </div>
      </>),

      grow: 2,
      wrap: true,
    },
    {
      name: "Borrar Marcados",
      selector: (row) => (<>
        <div className="ordenAct mx-5">
          <div className="col">
            <input
              type="checkbox"
              name="checkBorrarPuesto"

              title="Selecciona para poder borrar puesto"
              aria-label={`Selecciona para borrar el puesto ${row.codcentro} - ${row.centro} - ${row.codconsejeria} - ${row.consejeria}`}
              id=""
              className="form-check-input"
              onChange={(event) => handleListaPuestoBorrar(event.target.checked, row.xeocencon
              )}
            />        </div>
        </div>
      </>),
      style: {
        textAlign: 'center'
      },
      grow: 1,
      wrap: true,
    },
  ];
  // const [centrosElegidos, setCentrosElegidos] = useState([]);

  

  const handleGetOrder = (e) => {
    for (let i = 0; i < e.selectedRows.length; i++) {
      if (e.selectedRows.length > 0) {
        e.selectedRows[i].preferencia = i + 1;
        e.selectedRows[i].value = i + 1;
      }
      
    }
  };

  // if (adscripcion === "F") {
  //   ConstantesTabla.columnasTablaSeleccionPuestos.forEach((col) => {
  //     columnas.push(col);
  //   });
  // } else {
  //   ConstantesTabla.columnasTablaSeleccionCentros.forEach((col) => {
  //     columnas.push(col);
  //   });
  // }

  useEffect(() => {
    if (
      localStorage.getItem("centrosSeleccionados") !== undefined &&
      localStorage.getItem("centrosSeleccionados") !== null
    ) {
      // setCentrosElegidos(
      //   JSON.parse(localStorage.getItem("centrosSeleccionados"))
      // );
    }
    setLoading(true);
  }, []);

  // const rellenarInputs = (e) => {
  //   let nomPuesto =
  //     e.target.parentElement.nextElementSibling.children[0].innerText;
  //   for (let i = 0; i < puestosElegidos.length; i++) {
  //     if (nomPuesto.startsWith(puestosElegidos[i].xpt)) {
  //       puestosElegidos[i].preferencia = parseInt(e.target.value);
  //     }
  //   }
  // };

  const handleClose = (e) => {
    setShow(false);
  };

  useEffect(() => {
    getCentrosSeleccionados(params.idCon, params.idSol).then((data) => {
      
      setCentrosSeleccionados(data)
    })
  }, [params])

  useEffect(() => {
    if (centrosSeleccionados) {
      

      // const defaultOrden = puestosSeleccionados.map((row, index) => ({
      //   xpt: row.xpt,
      //   orden: index + 1,
      // }));
      setNuevoOrdenCentrosSeleccionados(centrosSeleccionados);
    }
  }, [centrosSeleccionados]);
  return (
    <>
      <Header></Header>
      {/*<Titulo
        tipo={"tituloPagina"}
        titulo={"Relación de Centros por Orden de Preferencia"}
      />*/}
      <h2 className="tituloPagina">Relación de Centros por Orden de Preferencia</h2>

      <div className="containerCentrosOrdenPref" role="main" data-landmark-index="4">
        <div className="mensajeInfo fondo">
          <p>
            <i className="fa-solid fa-caret-right me-3"></i>
            Listado de los puestos que hasta ahora ha seleccionado. Podrá
            realizar una reordenación de ellos, de acuerdo a sus preferencias.
            Utilizando el botón "Reordenar" podrá intercambiar el orden de los
            puestos.
          </p>
        </div>
        <div className={"vistaAnexos"}>
          {loading ? (
            // setIncludeFondo('vistaAnexos fondo')
            <>
              <div className="contTabla mt-5">


                <div className="container tablaPuestos card">
                  <DataTable
                    className="table-responsive"
                    columns={[...ConstantesTabla.columnaTablaCentrosSeleccionado, ...columnas]}
                    data={centrosSeleccionados}
                    pagination
                    paginationComponentOptions={ConstantesTabla.paginacionOpt}
                    noDataComponent={
                      <span>No se encontró ningún puesto seleccionado</span>
                    }
                    customStyles={ConstantesTabla.customStyles}
                    width="auto"
                    fixedHeader
                    fixedHeaderScrollHeight="600px"
                    onSelectedRowsChange={handleGetOrder}
                    subHeaderWrap={true}
                    style={{ marginTop: "20px" }}
                  />
                </div>
                <div className="d-flex justify-content-between mx-5">
                  <div className="">
                    <button
                      className="btn py-3 px-5  fw-100"
                      title="Reordenar centros"
                      aria-label="Botón para reodenar los centros seleccionados"
                      tabIndex={0}
                      disabled={bloquearReordeno}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          //TODO: Añadir Endpoint
                          
                          localStorage.removeItem("centrosSeleccionados");
                          
                          reodenarCentros(params.idCon, params.idSol, nuevoOrdenCentrosSeleccionados).then((data) => {
                            
                            

                            setCentrosSeleccionados(data)
                            const inputs = document.querySelectorAll('input[id^="nuevoOrden"]');

                            // Itera sobre cada input y vacía su valor
                            inputs.forEach(input => {
                              input.value = ''; // Vacía el valor del input
                            });
                          })
                        }
                      }}
                      onClick={(e) => {
                        //TODO: Añadir Endpoint
                        
                        localStorage.removeItem("centrosSeleccionados");
                        
                        reodenarCentros(params.idCon, params.idSol, nuevoOrdenCentrosSeleccionados).then((data) => {
                          
                          

                          setCentrosSeleccionados(data)
                          const inputs = document.querySelectorAll('input[id^="nuevoOrden"]');

                          // Itera sobre cada input y vacía su valor
                          inputs.forEach(input => {
                            input.value = ''; // Vacía el valor del input
                          });
                        })
                      }}>
                      Reordenar
                    </button>
                  </div>

                  <Button
                    clases="btn-card rounded bg-danger me-5 fw-bold"
                    nombre={"Borrar Seleccionados"}
                    funcion={(e) => {
                      //TODO: Añadir Endpoint
                      
                      eliminarCentros(params.idCon, params.idSol, listaCentroBorrar).then((data) => {
                        

                        setCentrosSeleccionados(data)

                      })

                    }}
                  />
                </div>
                <div className="buttons d-flex justify-content-center row">
                  {/* <ButtonVolver
                  clases={"fw-bold btnRed w-10"}
                    destino={
                      (params.idcon !== null || params.idcon !== "") &&
                        (params.idsol !== null || params.idsol !== "")
                        ? `consModSolicitudes/${params.idCon}/${params.idSol}`
                        : -1
                    }
                  ></ButtonVolver> */}
                  <div className="col-2">
                    <button
                      type="button"
                      className="btnRed rounded btnCancelarDocumentacion py-3 px-4 align-items-center"
                      onClick={() =>
                        navigate((params.idcon !== null || params.idcon !== "") &&
                          (params.idsol !== null || params.idsol !== "")
                          ? `/consModSolicitudes/${params.idCon}/${params.idSol}`
                          : -1)
                      }
                    >
                      <i className="fa-solid fa-rotate-left"></i> Volver
                    </button>
                  </div>

                  {/* Boton para insertar los puestos recibidos en el location.state */}
                  {/* <Button
                    clases="btn-card"
                    nombre={"Guardar"}
                    funcion={(e) => {
                      //TODO: Añadir Endpoint
                      
                      localStorage.removeItem("puestosSeleccionados");
                      
                      setShow({
                        mensaje: true,
                        content: "Puestos ordenados correctamente",
                        tipo: "tituloModal",
                        destinoCerrar: null,
                      })
                    }}
                  /> */}
                </div>
              </div>
            </>
          ) : (
            //   setIncludeFondo('vistaAnexos')
            <span>
              <SpinnerCircle />
            </span>
          )}
        </div>
      </div>
      <Footer></Footer>
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.content}
          tipo={show.tipo}
          //aviso={show.aviso}
          //destinoAviso={show.destinoAviso}
          destinoCerrar={show?.destinoCerrar}
        ></ModalMensajes>
      ) : null}
    </>
  );
};

export default CentrosOrdenPreferencia;
